import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, inject } from '@angular/core';
import { NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() apptitle: string;

  @Input() showBackButton: boolean;

  @Input() showSearchForm: boolean;

  @Output() searchExecuted: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('signInNgForm') signInNgForm: NgForm;
  signInForm: UntypedFormGroup;


  auth = inject(AuthService)
  constructor(private router: Router,
    private _activatedRoute: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
  ) {
    // Create the form
    this.signInForm = this._formBuilder.group({
      search: ['', [Validators.required]],
    });
  }

  get searchField() {
    return this.signInForm.get('search').value;
  }

  set searchField(value: string) {
    this.signInForm.get('search').setValue(value, { emitEvent: true });
  }

  callback: any

  ngOnInit(): void {
    this.signInForm.get('search').setValue('', { emitEvent: false });

    this._activatedRoute.queryParams.subscribe((params) => {
      if (params['search']) {
        this.searchField = params['search'];
        this.onSubmit();
      }
    });

    let code = "";
    let reading = false;

    this.callback = (e) => {

      //usually scanners throw an 'Enter' key at the end of read
      if (e.key == 'Enter') {
        if (code.length > 10) {
          /// code ready to use
          this.searchField = code;
          code = "";
          //this.barcodeSearh();
          this.onSubmit();
        }
      } else {
        if (e.key) {

          code += e.key; //while this is not an 'enter' it stores the every key
        }
      }
      //run a timeout of 200ms at the first read and clear everything
      if (!reading) {
        reading = true;
        setTimeout(() => {
          code = "";
          reading = false;
        }, 200);  //200 works fine for me but you can adjust it
      }
    };

    document.addEventListener('keypress', this.callback);

    if (this.showSearchForm) {
      document.addEventListener('keypress', this.callback);
    } else {
      document.removeEventListener('keypress', this.callback);
    }

    this.signInForm.get('search').valueChanges.subscribe((value) => {
      this.onSubmit();
    });
  }

  onSubmit() {

    if (this.signInForm.invalid) {
      return;
    }

    this.searchExecuted.emit(this.searchField);
  }


  logout() {
    this.auth.signOut().subscribe(() => {
      this.router.navigate(['/sign-in']);
    });
  }



}
